/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createReplacer } from '../../factoriesAny.js';
export var replacerDependencies = {
  createReplacer
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesReplacer.generated.js
// module id = 1452
// module chunks = 2